import createPromisesReducer from './reducers';
export * from './selectors';

export default createPromisesReducer;



// WEBPACK FOOTER //
// ./src/redux-modules/pending-promises/index.js